var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "properties-field", attrs: { id: _vm.id } },
    [
      _c("div", { staticClass: "wrap-properties" }, [
        _c("div", { staticClass: "properties-field-title" }, [
          _c("h4", { staticClass: "title" }, [_vm._v("Configuration")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "close-properties",
              on: {
                click: function($event) {
                  !_vm.showModalFieldLibrary ? _vm.closeConfiguration() : null
                }
              }
            },
            [_vm._v("\n        ×\n      ")]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "properties-field-content properties-field-content-config"
          },
          [
            _c(
              "div",
              { staticClass: "section-field input-field" },
              [
                _c("h4", { staticClass: "title-section" }, [_vm._v("General")]),
                _vm._v(" "),
                _c(
                  "b-form",
                  {
                    staticClass: "input-field m__b--14",
                    class: { "error-input": _vm.$v.dataSetup.title.$error }
                  },
                  [
                    _c("label", [_vm._v(" Title ")]),
                    _vm._v(" "),
                    _c("j-input", {
                      attrs: {
                        "error-required": false,
                        placeholder: "Enter title view"
                      },
                      model: {
                        value: _vm.dataSetup.title,
                        callback: function($$v) {
                          _vm.$set(_vm.dataSetup, "title", $$v)
                        },
                        expression: "dataSetup.title"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "section-field input-field" }, [
              _c("h4", { staticClass: "title-section" }, [
                _vm._v("Event List")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "configuration-section" },
                [
                  _c("h4", { staticClass: "configuration-section-title" }, [
                    _vm._v("Parse value to column")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "configuration-section-desc" }, [
                    _vm._v(
                      "\n            Select column to mapping parse data\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    {
                      class: {
                        "error-input": _vm.$v.dataSetup.column.title.$error
                      }
                    },
                    [
                      _c("label", [_vm._v(" Title ")]),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: {
                          options: _vm.variables.text,
                          placeholder: "Select Column",
                          label: "label"
                        },
                        model: {
                          value: _vm.dataSetup.column.title,
                          callback: function($$v) {
                            _vm.$set(_vm.dataSetup.column, "title", $$v)
                          },
                          expression: "dataSetup.column.title"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    {
                      class: {
                        "error-input":
                          _vm.$v.dataSetup.column.description.$error
                      }
                    },
                    [
                      _c("label", [_vm._v(" Description ")]),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: {
                          options: _vm.variables.text,
                          placeholder: "Select Column",
                          label: "label"
                        },
                        model: {
                          value: _vm.dataSetup.column.description,
                          callback: function($$v) {
                            _vm.$set(_vm.dataSetup.column, "description", $$v)
                          },
                          expression: "dataSetup.column.description"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    {
                      class: {
                        "error-input":
                          _vm.$v.dataSetup.column.start_date_time.$error
                      }
                    },
                    [
                      _c("label", [_vm._v(" Start Date Time ")]),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: {
                          options: _vm.variables.date,
                          placeholder: "Select Column",
                          label: "label"
                        },
                        model: {
                          value: _vm.dataSetup.column.start_date_time,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.dataSetup.column,
                              "start_date_time",
                              $$v
                            )
                          },
                          expression: "dataSetup.column.start_date_time"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    {
                      class: {
                        "error-input":
                          _vm.$v.dataSetup.column.end_date_time.$error
                      }
                    },
                    [
                      _c("label", [_vm._v(" End Date Time ")]),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: {
                          options: _vm.variables.date,
                          placeholder: "Select Column",
                          label: "label"
                        },
                        model: {
                          value: _vm.dataSetup.column.end_date_time,
                          callback: function($$v) {
                            _vm.$set(_vm.dataSetup.column, "end_date_time", $$v)
                          },
                          expression: "dataSetup.column.end_date_time"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    {
                      class: {
                        "error-input": _vm.$v.dataSetup.column.color.$error
                      }
                    },
                    [
                      _c("label", [_vm._v(" Color ")]),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: {
                          options: _vm.variables.text,
                          placeholder: "Select Column",
                          label: "label"
                        },
                        model: {
                          value: _vm.dataSetup.column.color,
                          callback: function($$v) {
                            _vm.$set(_vm.dataSetup.column, "color", $$v)
                          },
                          expression: "dataSetup.column.color"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "section-field input-field" }, [
              _c("h4", { staticClass: "title-section" }, [
                _vm._v("Data Source")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "configuration-section" },
                [
                  _c("div", { staticClass: "configuration-toggle-in-title" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "filter-option" }, [
                      _c("div", { staticClass: "filter-selected" }, [
                        _vm._v(_vm._s(_vm.dataSetup.filterOperator))
                      ]),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "fa fa-chevron-down",
                        on: {
                          click: function($event) {
                            _vm.showFilterOptions = true
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.showFilterOptions
                        ? _c("div", { staticClass: "filter-options" }, [
                            _c("p", [_vm._v("Operator")]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center justify-content-around"
                              },
                              _vm._l(_vm.filterOperatorOptions, function(
                                operator
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: operator.id,
                                    staticClass: "operator-option",
                                    class: {
                                      "operator-selected":
                                        operator.id ===
                                        _vm.dataSetup.filterOperator
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.closeFilterOptions(operator.id)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(operator.name) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              })
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("h3", { staticClass: "configuration-section-subtitle" }, [
                    _vm._v("By Value")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.dataSetup.filter, function(data, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "div-filter" },
                      [
                        _c("div", { staticClass: "header-filter" }, [
                          _c("div", { staticClass: "index" }, [
                            _vm._v(_vm._s(index + 1))
                          ]),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fa fa-trash",
                            on: {
                              click: function($event) {
                                _vm.deleteFilter(index)
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          { staticClass: "mb-2" },
                          [
                            _c("label", [_vm._v(" Column ")]),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                "error-required": false,
                                options: _vm.variables.options,
                                placeholder: "Select Column",
                                "value-format": "object",
                                label: "label"
                              },
                              model: {
                                value: data.key,
                                callback: function($$v) {
                                  _vm.$set(data, "key", $$v)
                                },
                                expression: "data.key"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          [
                            _c("label", [_vm._v(" Value ")]),
                            _vm._v(" "),
                            _c("j-input", {
                              attrs: {
                                "error-required": false,
                                placeholder: "Input Filter Value"
                              },
                              model: {
                                value: data.value,
                                callback: function($$v) {
                                  _vm.$set(data, "value", $$v)
                                },
                                expression: "data.value"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn-add-config",
                      on: { click: _vm.addFilter }
                    },
                    [_vm._v("\n            + Add Parameter\n          ")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "separator" }),
                  _vm._v(" "),
                  _c("h3", { staticClass: "configuration-section-subtitle" }, [
                    _vm._v("By Function")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.dataSetup.filter_function, function(data, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "div-filter" },
                      [
                        _c("div", { staticClass: "header-filter" }, [
                          _c("div", { staticClass: "index" }, [
                            _vm._v(_vm._s(index + 1))
                          ]),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fa fa-trash",
                            on: {
                              click: function($event) {
                                _vm.deleteFilterFunction(index)
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          { staticClass: "mb-2" },
                          [
                            _c("label", [_vm._v(" Column ")]),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                "error-required": false,
                                options: _vm.variables.options,
                                placeholder: "Select Column",
                                "value-format": "object",
                                label: "label"
                              },
                              model: {
                                value: data.key,
                                callback: function($$v) {
                                  _vm.$set(data, "key", $$v)
                                },
                                expression: "data.key"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          [
                            _c("label", [_vm._v(" Function ")]),
                            _vm._v(" "),
                            _c("j-single-select", {
                              attrs: {
                                options: _vm.listFunction,
                                placeholder: "Select Function",
                                "error-required": false,
                                label: "name"
                              },
                              model: {
                                value: data.value,
                                callback: function($$v) {
                                  _vm.$set(data, "value", $$v)
                                },
                                expression: "data.value"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn-add-config",
                      on: { click: _vm.addFilterFunction }
                    },
                    [_vm._v("\n            + Add Parameter\n          ")]
                  )
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "section-field input-field" }, [
              _c(
                "div",
                { staticClass: "configuration-section" },
                [
                  _c("h4", { staticClass: "configuration-section-title" }, [
                    _vm._v("Sorting")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "configuration-section-desc" }, [
                    _vm._v(
                      "\n            The displayed data can be sorted according to the specified parameters\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    {
                      staticClass: "mb-2",
                      class: {
                        "error-input": _vm.$v.dataSetup.sorting.key.$error
                      }
                    },
                    [
                      _c("label", [_vm._v(" Column ")]),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: {
                          "error-required": false,
                          options: _vm.variables.options,
                          placeholder: "Select column",
                          "value-format": "object",
                          label: "label"
                        },
                        model: {
                          value: _vm.dataSetup.sorting.key,
                          callback: function($$v) {
                            _vm.$set(_vm.dataSetup.sorting, "key", $$v)
                          },
                          expression: "dataSetup.sorting.key"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    {
                      staticClass: "mb-3",
                      class: {
                        "error-input": _vm.$v.dataSetup.sorting.order.$error
                      }
                    },
                    [
                      _c("label", [_vm._v(" Order Type ")]),
                      _vm._v(" "),
                      _c("j-single-select", {
                        attrs: {
                          "error-required": false,
                          options: _vm.orderOptions,
                          placeholder: "Select order type",
                          "value-format": "object",
                          label: "label"
                        },
                        model: {
                          value: _vm.dataSetup.sorting.order,
                          callback: function($$v) {
                            _vm.$set(_vm.dataSetup.sorting, "order", $$v)
                          },
                          expression: "dataSetup.sorting.order"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "section-field input-field" }, [
              _c("h4", { staticClass: "title-section" }, [
                _vm._v("Search Options")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "configuration-section" },
                [
                  _c("h4", { staticClass: "configuration-section-title" }, [
                    _vm._v("Fields")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "configuration-section-desc" }, [
                    _vm._v(
                      "\n            The field used can be adjusted as needed\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "draggable",
                    {
                      staticClass: "d-flex flex-wrap",
                      attrs: {
                        options: {
                          animation: 300,
                          handle: ".icon-drag"
                        }
                      },
                      model: {
                        value: _vm.dataSetup.search_options_list,
                        callback: function($$v) {
                          _vm.$set(_vm.dataSetup, "search_options_list", $$v)
                        },
                        expression: "dataSetup.search_options_list"
                      }
                    },
                    _vm._l(_vm.dataSetup.search_options_list, function(
                      data,
                      index
                    ) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "field-list",
                          class: { selected: index === _vm.selectedIndexField }
                        },
                        [
                          _c("p", { staticClass: "column-name" }, [
                            _vm._v(_vm._s(data.name))
                          ]),
                          _vm._v(" "),
                          _c("field-preview", { attrs: { column: data } }),
                          _vm._v(" "),
                          _c("div", { staticClass: "edit-or-delete" }, [
                            _c("div", { staticClass: "button" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "edit",
                                  on: {
                                    click: function($event) {
                                      _vm.editField(index)
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-pencil-square-o"
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "delete",
                                  on: {
                                    click: function($event) {
                                      _vm.deleteField(index)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-trash" })]
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    })
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn-add-config",
                      on: { click: _vm.openModalFieldLibrary }
                    },
                    [_vm._v("\n            + Add Field\n          ")]
                  )
                ],
                1
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "properties-field-button justify-content-end" },
          [
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c(
                "button",
                {
                  staticClass: "button-border mr-2",
                  attrs: { disabled: _vm.showModalFieldLibrary },
                  on: { click: _vm.closeConfiguration }
                },
                [_vm._v("\n          Close\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button-blue",
                  attrs: { disabled: _vm.showModalFieldLibrary },
                  on: { click: _vm.submitForm }
                },
                [_vm._v("\n          Apply\n        ")]
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _vm.selectedField
        ? _c("properties-field", {
            ref: _vm.idProperties,
            attrs: {
              id: [_vm.idProperties],
              "field-detail": _vm.selectedField,
              "variable-options": _vm.variables.options,
              "field-ui-key": _vm.dataSetup.search_options_list,
              "is-detail-view": true,
              "is-group": true,
              "is-new-field": _vm.isNewFieldGroup
            },
            on: {
              "delete-field": _vm.deleteField,
              "close-properties": function($event) {
                _vm.togglePropertiesField(false)
              },
              "submit-mode": _vm.submitField
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-title" }, [
      _c("h4", { staticClass: "configuration-section-title" }, [
        _vm._v("Filter")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "configuration-section-desc" }, [
        _vm._v(
          "\n                Filter data according to the parameters\n              "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72c439a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72c439a8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/partials/configuration/CalendarConfiguration.vue
// module id = null
// module chunks = 